import { Reveal, Overline } from "./Reveal";
import { CHAPTERS } from "../lib/site";

export const Manifesto = () => (
  <section id="why-us" data-testid="why-us-section" className="noise-dark scroll-mt-20 bg-lec-ink text-lec-bone">
    <div className="relative z-10 mx-auto max-w-7xl px-5 py-20 md:px-10 md:py-32">
      <Reveal>
        <Overline dark>Why choose us</Overline>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-semibold tracking-tight sm:text-5xl lg:text-6xl">
          The way we work, <span className="text-lec-green">chapter and verse.</span>
        </h2>
      </Reveal>

      <div className="mt-16 md:mt-20">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.05}>
            <div
              data-testid={`manifesto-chapter-${c.num}`}
              className="group grid gap-4 border-t border-lec-bone/15 py-10 transition-colors duration-300 hover:border-lec-green/60 md:grid-cols-12 md:gap-8 md:py-14"
            >
              <p className="font-display text-5xl font-semibold text-lec-green md:col-span-2 md:text-6xl">
                {c.num}
              </p>
              <h3 className="font-display text-2xl font-semibold tracking-tight sm:text-3xl md:col-span-4">
                {c.title}
              </h3>
              <p className="max-w-xl text-base leading-relaxed text-lec-bone/70 md:col-span-6">
                {c.copy}
              </p>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-lec-bone/15" />
      </div>
    </div>
  </section>
);
